<template>
  <section class="hero">
    <div class="hero-body">
      <div class="container has-text-centered">
        <h1 class="title">{{ name }}</h1>
        <slot></slot>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Hero",
  props: {
    name: String
  }
};
</script>
